import { stringify } from 'query-string';
import formatData from './formatData';
import { nodeAPIUrl } from '../constants';
import { fetchJson } from '.';

export default {
  getList: (
    resource: string,
    params: {
      pagination: { page: any; perPage: any };
      sort: { field: any; order: any };
      filter: any;
      meta?: any;
    }
  ) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;

    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify(params.filter),
      ...params.meta,
    };
    const url = `${nodeAPIUrl}/${resource}?${stringify(query)}`;

    return fetchJson(url).then(({ headers, json }) => {
      const total = parseInt(
        headers.get('content-range')?.split('/').pop() || '10',
        10
      );
      return {
        data: json.map((d: any) => formatData(resource, d)),
        total: total < json.length ? json.length : total,
      };
    });
  },

  getOne: (resource: string, params: { id: any }) =>
    fetchJson(`${nodeAPIUrl}/${resource}/${params.id}`).then(({ json }) => ({
      data: formatData(resource, json),
    })),

  getMany: (resource: string, params: { ids: any }) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    const url = `${nodeAPIUrl}/${resource}?${stringify(query)}`;
    return fetchJson(url).then(({ json }) => ({
      data: json.map((d: any) => formatData(resource, d)),
    }));
  },

  getManyReference: (
    resource: string,
    params: {
      pagination: { page: any; perPage: any };
      sort: { field: any; order: any };
      filter: any;
      target: any;
      id: any;
    }
  ) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify({
        ...params.filter,
        [params.target]: params.id,
      }),
    };
    const url = `${nodeAPIUrl}/${resource}?${stringify(query)}`;

    return fetchJson(url).then(({ headers, json }) => ({
      data: json.map((d: any) => formatData(resource, d)),
      total: parseInt(
        headers.get('content-range')?.split('/').pop() || '10',
        10
      ),
    }));
  },

  update: (resource: string, params: { id: any; data: any }) =>
    fetchJson(`${nodeAPIUrl}/${resource}/${params.id}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: formatData(resource, json) })),

  updateMany: (resource: string, params: { ids: any; data: any }) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return fetchJson(`${nodeAPIUrl}/${resource}?${stringify(query)}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({
      data: json.map((d: any) => formatData(resource, d)),
    }));
  },

  create: (resource: string, params: { data: any }) =>
    fetchJson(`${nodeAPIUrl}/${resource}`, {
      method: 'POST',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({
      data: formatData(resource, { ...params.data, id: json.id }),
    })),

  delete: (resource: string, params: { id: any }) =>
    fetchJson(`${nodeAPIUrl}/${resource}/${params.id}`, {
      method: 'DELETE',
    }).then(({ json }) => ({ data: formatData(resource, json) })),

  deleteMany: (resource: string, params: { ids: any }) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return fetchJson(`${nodeAPIUrl}/${resource}?${stringify(query)}`, {
      method: 'DELETE',
    }).then(({ json }) => ({
      data: json.map((d: any) => formatData(resource, d)),
    }));
  },
};
